import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { RingLoader } from 'react-spinners';

interface LoadingContainerProps {
  fullScreen?: boolean;
}

const LoadingContainer = styled.div<LoadingContainerProps>`
  ${tw`flex items-center justify-center`}
  ${props =>
    props.fullScreen
      ? tw`fixed inset-0 bg-black bg-opacity-20 z-40`
      : tw`w-full h-full min-h-[200px]`}
`;

interface LoadingSpinnerProps {
  color?: string;
  height?: number;
  width?: number;
  fullScreen?: boolean;
  containerClassName?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  color = '#4B5563', // Default gray-600
  fullScreen = false,
  containerClassName = '',
}) => (
  <LoadingContainer fullScreen={fullScreen} className={containerClassName}>
    <RingLoader color={color} size={30} />
  </LoadingContainer>
);

export default LoadingSpinner;
